import { LeagueInfo } from "../../Models/LeagueInfo/LeagueInfo";
import { getRegionNameById, getLeagueNameWithoutCountry } from "../../helpers";
import { LibConfig } from "../../init";
import { urlFormatter } from "sb-resp-utils";
export class LeaguesParser {
    parseData(league) {
        return new LeagueInfo(this.prepareData(league));
    }
    prepareData(league) {
        const optionalData = this.getOptionalData(league);
        const urlCode = urlFormatter.getLeagueUrl(league.name ? league.name : "");
        const regionName = getRegionNameById(league.regionId || "", LibConfig.allRegions);
        return {
            ID: optionalData.id,
            Name: league.name || "",
            SortID: optionalData.defaultOrder,
            RankID: optionalData.defaultOrder,
            MasterEvents: [],
            LiveMasterEvents: [],
            hasCombos: false,
            EventTypes: [],
            IsHot: league.isTopLeague || false,
            hasLiveEvents: this.getHasLiveEvents(league),
            visible: true,
            isExpanded: false,
            CountryID: optionalData.regionId,
            BranchID: optionalData.sportId,
            Code: urlCode,
            hasLiveStream: this.getHasLiveStream(league),
            BranchName: league.sportName || "",
            CountryCode: optionalData.regionId,
            hasFastMarkets: false,
            CountryTranslatedName: regionName,
            MasterLeagueID: optionalData.masterLeagueId,
            UrlCode: urlCode,
            isUserCountry: this.getIsUserCountry(league),
            EventsCount: this.getEventsCount(league),
            LeagueNameWithoutCountry: getLeagueNameWithoutCountry(league, regionName)
        };
    }
    getHasLiveEvents(league) {
        return (league.liveFixturesTotalCount !== undefined && league.liveFixturesTotalCount > 0)
            || (league.liveOutrightsTotalCount !== undefined && league.liveOutrightsTotalCount > 0);
    }
    getHasLiveStream(league) {
        return league.tags !== undefined && league.tags.indexOf("LiveStream") > -1;
    }
    getIsUserCountry(league) {
        return league.regionId !== undefined && LibConfig.regionIds.indexOf(league.regionId) > -1;
    }
    getEventsCount(league) {
        return (league.fixturesTotalCount || 0) + (league.outrightsTotalCount || 0);
    }
    getOptionalData(league) {
        return {
            id: league.id ? parseInt(league.id) : 0,
            regionId: league.regionId ? parseInt(league.regionId) : 0,
            masterLeagueId: league.masterLeagueId ? parseInt(league.masterLeagueId) : 0,
            sportId: league.sportId ? parseInt(league.sportId) : 0,
            defaultOrder: league.defaultOrder || 0
        };
    }
}
//# sourceMappingURL=LeaguesParser.js.map